module.exports = __webpack_public_path__ + "static/media/error-without-sign.9245b7f1.png";